import { TopToolbar } from "./TopToolbar";
import React from "react";
import { DispatchContext } from "../store";
import { ReflexContainer, ReflexElement } from "react-reflex";
import { snippetsVersionsEqual } from "../services/snippetService";
import { AppModel } from "../models";

import "react-reflex/styles.css";
import { SearchPanel } from "./SearchPanel";
import { DescriptionBLock } from "./DescriptionBlock";
import { SiteWideView } from "./SiteWideView";
import { SiteDefaultView } from "./SiteDefaultView";

interface SiteViewProps {
  state: AppModel;
  versions: string;
}

export const SiteView = ({ state, versions }: SiteViewProps) => {
  const { dispatch } = React.useContext(DispatchContext);
  const isJsSaved =
    snippetsVersionsEqual(
      state.savedSnippet.jsSettings,
      state.snippet.jsSettings
    ) && state.savedSnippet.jsCode === state.snippet.jsCode;

  const descriptionVisible =
    state.snippet.description ||
    state.snippet.buttonHref ||
    state.snippet.buttonText;

  return (
    <>
      <main
        className={`st-body ${state.darkTheme ? "dark-theme" : ""} ${
          descriptionVisible ? "with-description" : ""
        }`}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <div className="st-main-content">
          <TopToolbar
            onSaveClick={() =>
              dispatch({ type: "SnippetSaveClick", snippet: state.snippet })
            }
            title={state.snippet.title}
            tagsIds={state.snippet.tagsIds.filter((tId) => state.tags.has(tId))}
            tags={state.tags}
            isDarkTheme={state.darkTheme}
            onTagClick={(tag) => {
              dispatch({ type: "TagClick", tag });
              dispatch({ type: "SearchPhraseChanged", text: `#${tag}` });
            }}
            onNewClick={() => dispatch({ type: "SnippetNewClick" })}
            onThemeSelect={(dark: boolean) =>
              dispatch({ type: "ThemeChanged", darkTheme: dark })
            }
            url={document.location.href}
            sharePopupVisible={state.sharePopupVisible}
            onCopyClick={() => dispatch({ type: "CopyToClipboardClick" })}
            onSharePopupClose={() =>
              dispatch({ type: "ShareWindowCloseClick" })
            }
            mode={state.mode}
          />
          <ReflexContainer orientation="horizontal">
            <ReflexElement>
              <ReflexContainer
                orientation="vertical"
                style={{ background: state.darkTheme ? "#000000" : "#e5e5e5" }}
                windowResizeAware={true}
              >
                <ReflexElement
                  className="st-search"
                  minSize={state.searchPanelVisible ? 300 : 44}
                  maxSize={state.searchPanelVisible ? 300 : 44}
                  style={{ paddingTop: state.searchPanelVisible ? "99px" : 0 }}
                >
                  <SearchPanel
                    searchText={state.searchText}
                    searchResults={state.searchResults}
                    placeVisisble={state.searchPanelVisible}
                    samplesCount={state.samplesCount}
                    onSearchClose={() => dispatch({ type: "SearchCloseClick" })}
                    onSearchClick={() => dispatch({ type: "SearchClick" })}
                    onSearchPhraseChange={(text) =>
                      dispatch({ type: "SearchPhraseChanged", text })
                    }
                    onSearchResultSelected={(id) =>
                      dispatch({ type: "SearchSnippetSelected", id })
                    }
                    currentSnippetId={state.snippet.id}
                  />
                </ReflexElement>
                <ReflexElement>
                  {!state.mode ? (
                    <SiteDefaultView
                      state={state}
                      isJsSaved={isJsSaved}
                      versions={versions}
                    />
                  ) : (
                    <SiteWideView
                      state={state}
                      versions={versions}
                      isJsSaved={isJsSaved}
                    />
                  )}
                </ReflexElement>
              </ReflexContainer>
              <ReflexElement>
                {descriptionVisible ? (
                  <DescriptionBLock
                    description={state.snippet.description}
                    buttonHref={state.snippet.buttonHref}
                    buttonText={state.snippet.buttonText}
                  />
                ) : null}
              </ReflexElement>
            </ReflexElement>
          </ReflexContainer>
        </div>
      </main>
    </>
  );
};
